export default {
  result: {
    err: "订单信息错误。",
    success: "支付成功",
    paymoney: "支付金额: ",
    yuan: " 元",
    order: {
      describe: "支付信息",
      name: "商户名称：",
      no: "订单号：",
      paytime: "支付时间：",
    },
    detail: {
      describe: "明细信息",
      project: "收费项目：",
      range: "收费区间：",
      money: "金额：",
      remark: "备注信息",
    },
    ticket: {
      describe: "票据信息",
      title: "抬头：",
      type: "票据类型：",
      idtype: "纳税人识别号：",
      email: "邮箱：",
    },
  },
  home: {
    homepage: "首页",
    title: "交费大厅",
  },
  "unpaid-fee": {
    title: "待交费用",
  },
  "pay-confirm": {
    title: "交费确认",
  },
  "pay-confirm-second": {
    title: "交费确认",
  },
  "choose-fee": {
    title: "选交费用",
  },
  "choose-fee-detail": {
    title: "选交费用详细",
  },
  "pay-record": {
    title: "付款记录",
  },
  "pay-record-detail": {
    title: "付款记录详情",
  },
  "pay-refund": {
    title: "退费记录",
  },
  "pay-situation": {
    title: "交费记录",
  },
  "pay-situation-detail": {
    title: "交费记录详细",
  },
  "pay-situation-download": {
    title: "下载票据",
  },
  pay_suc: {
    title: "交费成功",
  },
  "qrcode-pay": {
    title: "支付",
  },
  pay_situation: {
    download: {
      title: "下载票据",
      name: "收费项目",
      money: "交费金额",
      date: "交费日期",
      code: "票据号码",
      download: "下载票据",
      close: "关闭",
      tips: "没有可下载的票据",
    },
    list: {
      name: "收费项目",
      range: "交费区间",
      need_money: "应交",
      later_money: "缓交",
      receive_money: "实交",
      operate: "操作",
      detail: "查看详情",
      download: "下载票据",
      noRange: "无区间年度",
      allRange: "全部",
    },
  },
  pay_situation_detail: {
    sum_need_pay: "当前应交合计",
    sum_already_pay: "已交合计",
    standard: "应交",
    discount: "减免",
    deduction: "抵扣",
    laterVos: "缓交",
    reditVos: "贷款",
    payTikectVos: "已交记录",
    expire: "到期",
    ticketNum: "票据号",
    nowMoney: "当前需交",
    close: "关闭",
  },
  pay_ticket: {
    ticket_info: "开票信息",
    ticket_detail: "订单明细",
    name: "姓名",
    code: "学工号",
    bussiness_code: "证件号码",
    sum: "合计金额：",
    commit: "提交",
    add: "新增",
    cancel: "取消",
    search: "查询",
    person: "开具个人票据",
    person_tips: "部分收费项目只能使用个人抬头开票。",
    person_placeholder: "请输入票据抬头",
    organ: "开具企业、机构票据",
    organ_placeholder: "请输入机构关键字查询机构抬头",
    add_tips: "当前未选择任何票据抬头，请先查询并选择机构抬头，或",
    add_ticket: "新增一个机构抬头",
    add_organ: "新增机构抬头",
    select_organ: "选择机构抬头",
    close: "关闭",
    check: "选择",
    tips: "请输入机构关键字",
    confirm_add_title: "没有符合条件的机构抬头，是否新增抬头？",
    title_not_sysu: "票据抬头不能为中山大学",
    estate_date_needed: "不动产租赁收费需要输入租赁日期！",
    estate_addr_lost: "不动产租赁收费尚未设定地址信息，请联系负责该收费部门的老师！",
    organ_model: {
      name: "名称",
      taxNumber: "税号",
      address: "单位地址",
      tele: "电话号码",
      depositBank: "开户银行",
      bank: "银行账户",
      name_rule: "请填写机构名称",
      taxNumber_rule: "请填写机构税号",
    },
  },
  pay_confirm: {
    ticket_info: "订单信息",
    ticketNum: "订单号",
    money: "金额",
    paytype: "支付方式",
    please: "请在",
    please2: "内完成支付",
    timeformat: "mm分ss秒",

    tips: "提示",
    pay_finish: "支付已完成",
    pay_fail: "支付失败",
    pay_canceled: "已取消支付",
    pay_change: "支付未完成，更改支付方式",
    pay_error: "支付时遇到问题",
    pay_cancel: "取消支付",
    pay_error_title: "支付出问题",
    pay_error_tips: `请记录以下信息，并联系收费老师处理。`,
    pay_error_tips2: `若未扣钱，可取消订单重新交费。`,
    close: "关闭",
    cancel_repay: "取消订单，重新交费",
    timeout_tip: "订单已过期，请刷新页面后重新提交订单。",
    state: {
      confirm: "确定",
      fresh: "刷新订单",
    },
  },
  choose_fee: {
    range: "交费区间",
    price: "单价",
    money: "收费金额",
    count: "数量",
    maxMoneyMust: "请输入金额",
    maxMoneyStart: "交费上限：￥",
    maxMoneyEnd: "",
    remark: "备注",
    pay: "去交费",
    sum: "合计金额",
    default_range: "默认区间",
    clear: "无选交费用",
  },
  pay_record: {
    list: {
      code: "订单编号",
      money: "金额",
      pay_type: "支付方式",
      pay_date: "支付时间",
      operate: "操作",
      detail: "查看详情",
      starttime: "开始日期",
      endtime: "结束日期",
      to: "至",
      search: "查询",
    },
    detail: {
      title: "付款详情",
      pay_info: "支付信息",
      pay_detail: "订单明细",
      code: "订单编号",
      status: "订单状态",
      money: "订单金额",
      create_time: "创建时间",
      pay_type: "支付方式",
      pay_time: "支付时间",
      ticket_title: "票据抬头",
      close: "关闭",
    },
  },
  pay_refund: {
    list: {
      project: "收费项目",
      range: "收费区间",
      money: "退费金额",
      type: "退费方式",
      date: "退费日期",
      state: "退费状态",
    },
  },
  message: {
    // 所有的提示信息
    ticketTitle: "请填写抬头信息",
    selectFee: "请选择应收项目",
  },
  router: {
    pay: {
      unpaid_fee: "待交费用",
      choose_fee: "选交费用",
      pay_situation: "交费情况",
      refund_record: "退费记录",
      pay_record: "付款记录",
    },
    confirm: {
      pay_ticket: "交费确认",
      pay_confirm: "待支付",
    },
    anonymous: {
      anonymous_pay: "不记名交费",
    },
  },
  success: {
    logout: {
      message: "您确定要退出登录？",
      title: "退出",
      confirmButtonText: "退出",
      cancelButtonText: "取消",
      successMessage: "成功登出",
    },
  },
  error: {
    network: "服务器君开小差了，请稍后再试。",

    message: "{message}",
    messageCause: "{message}</br>错误原因：{cause}",
    cause: "错误原因：{cause}",
    unknown: "未知错误，错误码：{state}",
    // 400: '400请求错误',
    400: "请求发生错误，请重试。",
    401: "401未授权，请登录",
    403: "403拒绝访问",
    404: "404请求地址出错: {url}",
    408: "408请求超时",
    500: "500服务器内部错误",
    501: "501服务未实现",
    502: "502网关错误",
    503: "503服务不可用",
    504: "504网关超时",
    505: "505HTTP版本不受支持",
    state: {
      6010101: "非法请求",
      6020101: "用户名或密码错误",
    },
  },
};
